import { render, staticRenderFns } from "./hireful-notification.vue?vue&type=template&id=15205efb&"
import script from "./hireful-notification.vue?vue&type=script&lang=js&"
export * from "./hireful-notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports